import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { track } from '../utils/mixpanel';

/**
 * Test with http://localhost:3000/qr-proxy?utm_source=machine_b3253c1b-09f7-42e6-a54c-0045199b6f2c&utm_medium=buffalo+wild+wings&utm_campaign=download-draft-kings&target=https://google.com
 */
const QrProxy = () => {
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const targetUrl = searchParams.get('target');

        // Identify the QR Code e.g. "download-draft-kings" or "new-users-five-dollar-free-play"
        const campaign = searchParams.get('utm_campaign') ?? undefined;

        // The machineID
        const source = searchParams.get('utm_source') ?? undefined;

        // Typically the machine "Location"
        const medium = searchParams.get('utm_medium') ?? undefined;

        track('QR Code Scanned', {
            campaign: campaign,
            source: source,
            machineId: source,
            medium: medium,
        });

        if (targetUrl) {
            window.location.replace(targetUrl);
        }
    }, [searchParams]);

    return null;
};

export { QrProxy };
